import { TabListFieldsFragment } from "@src/generated/graphql";
import {
  highlightBracketedText,
  highlightUnderscoreText,
} from "src/utils/utils";
import React from "react";
import BlankImage from "src/images/new_rect_agentic.png";
import DynamicMedia from "src/components/shared/DynamicMedia";
type OurApproachComponentProps = {
  content: TabListFieldsFragment;
  isHomePage?: boolean;
  className?: string;
};

const OurApproachComponent = ({ content, isHomePage, className  }: OurApproachComponentProps) => {
  const { title, eyebrowText, tabListdescriptionJson, tabsCollection  , backgroundImage} =
    content;
   
  const [activeTabIndex, setActiveTabIndex] = React.useState(0);
  const descriptionText =
    tabListdescriptionJson?.json?.content?.[0]?.content?.[0]?.value ?? "";

  const isTabListEnterprise = content?.internalName === "tab_list_enterprise";

  return (
    <div className="marketing-platform" > 
      <div className={`marketing-platform__container  container-fluid custom-spacer-col ${className}`}   style={isHomePage ? { backgroundImage: `url(${backgroundImage?.url ?? ""})` } : {}}>
        <div className="marketing-platform__header">
          <span
            className="highlight-bracket-text"
            style={{ color: "white" }}
            dangerouslySetInnerHTML={{
              __html: highlightBracketedText(title ?? "", "bold"),
            }}
          />
          <p className="marketing-platform__subtitle">{eyebrowText}</p>
          {descriptionText && (
            <p
              className="marketing-platform__description"
              dangerouslySetInnerHTML={{
                __html: highlightUnderscoreText(descriptionText ?? ""),
              }}
            />
          )}
        </div>

        <div className="marketing-platform__tabs">
          <div className="marketing-platform__tabs-inner">
            {tabsCollection?.items.map((tab, index) => {
              if (!tab) return null;
              return (
                <button
                  key={tab.sys.id || index}
                  onClick={() => setActiveTabIndex(index)}
                  className={`marketing-platform__tab-button ${
                    activeTabIndex === index ? "active" : ""
                  }`}
                >
                  {tab.tabTitle}
                </button>
              );
            })}
          </div>
        </div>

        {tabsCollection?.items.map((tab, index) => {
          if (!tab || activeTabIndex !== index) return null;

          const description =
            tab.tabDescription?.json?.content?.[0]?.content?.[0]?.value;
          const subDescription =
            tab.tabSubDescription?.json?.content?.[0]?.content?.[0]?.value;
          const image = tab?.tabForegroundImage?.url;

          return (
            <div
              key={tab.sys.id || index}
              className="marketing-platform__content"
            >
              <div
                className="marketing-platform__content-image"
                style={
                  image?.endsWith(".json")
                    ? {
                        height:
                          "clamp(400px, calc(400px + (100vw - 500px) * 0.2), 600px)",
                      }
                    : {}
                }
              >
                <DynamicMedia
                  src={image ?? ""}
                  alt={tab?.tabForegroundImage?.title ?? ""}
                  ariaLabel={tab?.tabForegroundImage?.title ?? ""}
                  lottieClassName="lottie"
                  lottieProps={{
                    loop: true,
                  }}
                />
              </div>

              <div className="marketing-platform__content-info">
                {isTabListEnterprise && (
                  <p
                    className="marketing-platform__content-eyebrow"
                    dangerouslySetInnerHTML={{
                      __html: highlightUnderscoreText(tab.tabTitle ?? ""),
                    }}
                  />
                )}

                {description && (
                  <h2 className="marketing-platform__content-title">
                    {description}
                  </h2>
                )}

                {subDescription && (
                  <p
                    className={`marketing-platform__content-description ${isTabListEnterprise ? "light" : ""}`}
                    dangerouslySetInnerHTML={{
                      __html: highlightUnderscoreText(subDescription ?? ""),
                    }}
                  />
                )}

                <div className="marketing-platform__features">
                  {tab.infoItemsCollection?.items.map((infoItem, itemIndex) => {
                    if (!infoItem) return null;
                    return (
                      <FeatureItem
                        key={infoItem.sys.id || itemIndex}
                        title={infoItem.itemText || ""}
                        description={
                          infoItem.itemDescriptionJson?.json?.content?.[0]
                            ?.content?.[0]?.value || ""
                        }
                        icon={infoItem?.icon?.url || ""}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const FeatureItem = ({
  title,
  description,
  icon,
}: {
  title: string;
  description: string;
  icon: string;
}) => (
  <div className="feature-item">
    <div className="feature-item__icon">
      <img src={icon} alt="icon-home-tablist" />
    </div>
    <div className="feature-item__content">
      <h3 className="feature-item__title">{title}</h3>
      <p className="feature-item__description">{description}</p>
    </div>
  </div>
);
export default OurApproachComponent;
